module.exports = __webpack_public_path__ + "img/silhouette-int.5e5dd9ec.svg";